export const COUNTRIES = Object.freeze([
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua And Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo, Democratic Republic of the",
  "Congo, Republic of the",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, North",
  "Korea, South",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
]);

export const COUNTRY_WITH_CODES = Object.freeze([
  { name: "Afghanistan", code: "+93", isoCode: "AF" },
  { name: "Albania", code: "+355", isoCode: "AL" },
  { name: "Algeria", code: "+213", isoCode: "DZ" },
  { name: "Andorra", code: "+376", isoCode: "AD" },
  { name: "Angola", code: "+244", isoCode: "AO" },
  { name: "Antigua And Barbuda", code: "+1-268", isoCode: "AG" },
  { name: "Argentina", code: "+54", isoCode: "AR" },
  { name: "Armenia", code: "+374", isoCode: "AM" },
  { name: "Australia", code: "+61", isoCode: "AU" },
  { name: "Austria", code: "+43", isoCode: "AT" },
  { name: "Azerbaijan", code: "+994", isoCode: "AZ" },
  { name: "Bahamas", code: "+1-242", isoCode: "BS" },
  { name: "Bahrain", code: "+973", isoCode: "BH" },
  { name: "Bangladesh", code: "+880", isoCode: "BD" },
  { name: "Barbados", code: "+1-246", isoCode: "BB" },
  { name: "Belarus", code: "+375", isoCode: "BY" },
  { name: "Belgium", code: "+32", isoCode: "BE" },
  { name: "Belize", code: "+501", isoCode: "BZ" },
  { name: "Benin", code: "+229", isoCode: "BJ" },
  { name: "Bhutan", code: "+975", isoCode: "BT" },
  { name: "Bolivia", code: "+591", isoCode: "BO" },
  { name: "Bosnia and Herzegovina", code: "+387", isoCode: "BA" },
  { name: "Botswana", code: "+267", isoCode: "BW" },
  { name: "Brazil", code: "+55", isoCode: "BR" },
  { name: "Brunei", code: "+673", isoCode: "BN" },
  { name: "Bulgaria", code: "+359", isoCode: "BG" },
  { name: "Burkina Faso", code: "+226", isoCode: "BF" },
  { name: "Burundi", code: "+257", isoCode: "BI" },
  { name: "Cambodia", code: "+855", isoCode: "KH" },
  { name: "Cameroon", code: "+237", isoCode: "CM" },
  { name: "Canada", code: "+1", isoCode: "CA" },
  { name: "Cape Verde", code: "+238", isoCode: "CV" },
  { name: "Central African Republic", code: "+236", isoCode: "CF" },
  { name: "Chad", code: "+235", isoCode: "TD" },
  { name: "Chile", code: "+56", isoCode: "CL" },
  { name: "China", code: "+86", isoCode: "CN" },
  { name: "Colombia", code: "+57", isoCode: "CO" },
  { name: "Comoros", code: "+269", isoCode: "KM" },
  { name: "Congo (DRC)", code: "+243", isoCode: "CD" },
  { name: "Congo (Republic)", code: "+242", isoCode: "CG" },
  { name: "Costa Rica", code: "+506", isoCode: "CR" },
  { name: "Croatia", code: "+385", isoCode: "HR" },
  { name: "Cuba", code: "+53", isoCode: "CU" },
  { name: "Cyprus", code: "+357", isoCode: "CY" },
  { name: "Czech Republic", code: "+420", isoCode: "CZ" },
  { name: "Denmark", code: "+45", isoCode: "DK" },
  { name: "Djibouti", code: "+253", isoCode: "DJ" },
  { name: "Dominica", code: "+1-767", isoCode: "DM" },
  { name: "Dominican Republic", code: "+1-809", isoCode: "DO" },
  { name: "Ecuador", code: "+593", isoCode: "EC" },
  { name: "Egypt", code: "+20", isoCode: "EG" },
  { name: "El Salvador", code: "+503", isoCode: "SV" },
  { name: "Equatorial Guinea", code: "+240", isoCode: "GQ" },
  { name: "Eritrea", code: "+291", isoCode: "ER" },
  { name: "Estonia", code: "+372", isoCode: "EE" },
  { name: "Eswatini", code: "+268", isoCode: "SZ" },
  { name: "Ethiopia", code: "+251", isoCode: "ET" },
  { name: "Fiji", code: "+679", isoCode: "FJ" },
  { name: "Finland", code: "+358", isoCode: "FI" },
  { name: "France", code: "+33", isoCode: "FR" },
  { name: "Gabon", code: "+241", isoCode: "GA" },
  { name: "Gambia", code: "+220", isoCode: "GM" },
  { name: "Georgia", code: "+995", isoCode: "GE" },
  { name: "Germany", code: "+49", isoCode: "DE" },
  { name: "Ghana", code: "+233", isoCode: "GH" },
  { name: "Greece", code: "+30", isoCode: "GR" },
  { name: "Grenada", code: "+1-473", isoCode: "GD" },
  { name: "Guatemala", code: "+502", isoCode: "GT" },
  { name: "Guinea", code: "+224", isoCode: "GN" },
  { name: "Guinea-Bissau", code: "+245", isoCode: "GW" },
  { name: "Guyana", code: "+592", isoCode: "GY" },
  { name: "Haiti", code: "+509", isoCode: "HT" },
  { name: "Honduras", code: "+504", isoCode: "HN" },
  { name: "Hungary", code: "+36", isoCode: "HU" },
  { name: "Iceland", code: "+354", isoCode: "IS" },
  { name: "India", code: "+91", isoCode: "IN" },
  { name: "Indonesia", code: "+62", isoCode: "ID" },
  { name: "Iran", code: "+98", isoCode: "IR" },
  { name: "Iraq", code: "+964", isoCode: "IQ" },
  { name: "Ireland", code: "+353", isoCode: "IE" },
  { name: "Israel", code: "+972", isoCode: "IL" },
  { name: "Italy", code: "+39", isoCode: "IT" },
  { name: "Jamaica", code: "+1-876", isoCode: "JM" },
  { name: "Japan", code: "+81", isoCode: "JP" },
  { name: "Jordan", code: "+962", isoCode: "JO" },
  { name: "Kazakhstan", code: "+7", isoCode: "KZ" },
  { name: "Kenya", code: "+254", isoCode: "KE" },
  { name: "Kiribati", code: "+686", isoCode: "KI" },
  { name: "Kuwait", code: "+965", isoCode: "KW" },
  { name: "Kyrgyzstan", code: "+996", isoCode: "KG" },
  { name: "Laos", code: "+856", isoCode: "LA" },
  { name: "Latvia", code: "+371", isoCode: "LV" },
  { name: "Lebanon", code: "+961", isoCode: "LB" },
  { name: "Lesotho", code: "+266", isoCode: "LS" },
  { name: "Liberia", code: "+231", isoCode: "LR" },
  { name: "Libya", code: "+218", isoCode: "LY" },
  { name: "Liechtenstein", code: "+423", isoCode: "LI" },
  { name: "Lithuania", code: "+370", isoCode: "LT" },
  { name: "Luxembourg", code: "+352", isoCode: "LU" },
  { name: "Madagascar", code: "+261", isoCode: "MG" },
  { name: "Malawi", code: "+265", isoCode: "MW" },
  { name: "Malaysia", code: "+60", isoCode: "MY" },
  { name: "Maldives", code: "+960", isoCode: "MV" },
  { name: "Mali", code: "+223", isoCode: "ML" },
  { name: "Malta", code: "+356", isoCode: "MT" },
  { name: "Marshall Islands", code: "+692", isoCode: "MH" },
  { name: "Mauritania", code: "+222", isoCode: "MR" },
  { name: "Mauritius", code: "+230", isoCode: "MU" },
  { name: "Mexico", code: "+52", isoCode: "MX" },
  { name: "Micronesia", code: "+691", isoCode: "FM" },
  { name: "Moldova", code: "+373", isoCode: "MD" },
  { name: "Monaco", code: "+377", isoCode: "MC" },
  { name: "Mongolia", code: "+976", isoCode: "MN" },
  { name: "Montenegro", code: "+382", isoCode: "ME" },
  { name: "Morocco", code: "+212", isoCode: "MA" },
  { name: "Mozambique", code: "+258", isoCode: "MZ" },
  { name: "Myanmar", code: "+95", isoCode: "MM" },
  { name: "Namibia", code: "+264", isoCode: "NA" },
  { name: "Nauru", code: "+674", isoCode: "NR" },
  { name: "Nepal", code: "+977", isoCode: "NP" },
  { name: "Netherlands", code: "+31", isoCode: "NL" },
  { name: "New Zealand", code: "+64", isoCode: "NZ" },
  { name: "Nicaragua", code: "+505", isoCode: "NI" },
  { name: "Niger", code: "+227", isoCode: "NE" },
  { name: "Nigeria", code: "+234", isoCode: "NG" },
  { name: "North Macedonia", code: "+389", isoCode: "MK" },
  { name: "Norway", code: "+47", isoCode: "NO" },
  { name: "Oman", code: "+968", isoCode: "OM" },
  { name: "Pakistan", code: "+92", isoCode: "PK" },
  { name: "Palau", code: "+680", isoCode: "PW" },
  { name: "Panama", code: "+507", isoCode: "PA" },
  { name: "Papua New Guinea", code: "+675", isoCode: "PG" },
  { name: "Paraguay", code: "+595", isoCode: "PY" },
  { name: "Peru", code: "+51", isoCode: "PE" },
  { name: "Philippines", code: "+63", isoCode: "PH" },
  { name: "Poland", code: "+48", isoCode: "PL" },
  { name: "Portugal", code: "+351", isoCode: "PT" },
  { name: "Qatar", code: "+974", isoCode: "QA" },
  { name: "Romania", code: "+40", isoCode: "RO" },
  { name: "Russia", code: "+7", isoCode: "RU" },
  { name: "Rwanda", code: "+250", isoCode: "RW" },
  { name: "Saint Kitts and Nevis", code: "+1-869", isoCode: "KN" },
  { name: "Saint Lucia", code: "+1-758", isoCode: "LC" },
  { name: "Saint Vincent and the Grenadines", code: "+1-784", isoCode: "VC" },
  { name: "Samoa", code: "+685", isoCode: "WS" },
  { name: "San Marino", code: "+378", isoCode: "SM" },
  { name: "Sao Tome and Principe", code: "+239", isoCode: "ST" },
  { name: "Saudi Arabia", code: "+966", isoCode: "SA" },
  { name: "Senegal", code: "+221", isoCode: "SN" },
  { name: "Serbia", code: "+381", isoCode: "RS" },
  { name: "Seychelles", code: "+248", isoCode: "SC" },
  { name: "Sierra Leone", code: "+232", isoCode: "SL" },
  { name: "Singapore", code: "+65", isoCode: "SG" },
  { name: "Slovakia", code: "+421", isoCode: "SK" },
  { name: "Slovenia", code: "+386", isoCode: "SI" },
  { name: "Solomon Islands", code: "+677", isoCode: "SB" },
  { name: "Somalia", code: "+252", isoCode: "SO" },
  { name: "South Africa", code: "+27", isoCode: "ZA" },
  { name: "South Korea", code: "+82", isoCode: "KR" },
  { name: "Spain", code: "+34", isoCode: "ES" },
  { name: "Sri Lanka", code: "+94", isoCode: "LK" },
  { name: "Sudan", code: "+249", isoCode: "SD" },
  { name: "Suriname", code: "+597", isoCode: "SR" },
  { name: "Sweden", code: "+46", isoCode: "SE" },
  { name: "Switzerland", code: "+41", isoCode: "CH" },
  { name: "Syria", code: "+963", isoCode: "SY" },
  { name: "Taiwan", code: "+886", isoCode: "TW" },
  { name: "Tajikistan", code: "+992", isoCode: "TJ" },
  { name: "Tanzania", code: "+255", isoCode: "TZ" },
  { name: "Thailand", code: "+66", isoCode: "TH" },
  { name: "Togo", code: "+228", isoCode: "TG" },
  { name: "Tonga", code: "+676", isoCode: "TO" },
  { name: "Trinidad and Tobago", code: "+1-868", isoCode: "TT" },
  { name: "Tunisia", code: "+216", isoCode: "TN" },
  { name: "Turkey", code: "+90", isoCode: "TR" },
  { name: "Turkmenistan", code: "+993", isoCode: "TM" },
  { name: "Tuvalu", code: "+688", isoCode: "TV" },
  { name: "Uganda", code: "+256", isoCode: "UG" },
  { name: "Ukraine", code: "+380", isoCode: "UA" },
  { name: "United Arab Emirates", code: "+971", isoCode: "AE" },
  { name: "United Kingdom", code: "+44", isoCode: "GB" },
  { name: "United States", code: "+1", isoCode: "US" },
  { name: "Uruguay", code: "+598", isoCode: "UY" },
  { name: "Uzbekistan", code: "+998", isoCode: "UZ" },
  { name: "Vanuatu", code: "+678", isoCode: "VU" },
  { name: "Vatican City", code: "+379", isoCode: "VA" },
  { name: "Venezuela", code: "+58", isoCode: "VE" },
  { name: "Vietnam", code: "+84", isoCode: "VN" },
  { name: "Yemen", code: "+967", isoCode: "YE" },
  { name: "Zambia", code: "+260", isoCode: "ZM" },
  { name: "Zimbabwe", code: "+263", isoCode: "ZW" }
]);

export const COUNTRIES_WITH_ISO = {
  "Afghanistan": "AF",
  "Albania": "AL",
  "Algeria": "DZ",
  "Andorra": "AD",
  "Angola": "AO",
  "Antigua And Barbuda": "AG",
  "Argentina": "AR",
  "Armenia": "AM",
  "Australia": "AU",
  "Austria": "AT",
  "Azerbaijan": "AZ",
  "Bahamas": "BS",
  "Bahrain": "BH",
  "Bangladesh": "BD",
  "Barbados": "BB",
  "Belarus": "BY",
  "Belgium": "BE",
  "Belize": "BZ",
  "Benin": "BJ",
  "Bhutan": "BT",
  "Bolivia": "BO",
  "Bosnia and Herzegovina": "BA",
  "Botswana": "BW",
  "Brazil": "BR",
  "Brunei": "BN",
  "Bulgaria": "BG",
  "Burkina Faso": "BF",
  "Burundi": "BI",
  "Cabo Verde": "CV",
  "Cambodia": "KH",
  "Cameroon": "CM",
  "Canada": "CA",
  "Central African Republic": "CF",
  "Chad": "TD",
  "Chile": "CL",
  "China": "CN",
  "Colombia": "CO",
  "Comoros": "KM",
  "Congo, Democratic Republic of the": "CD",
  "Congo, Republic of the": "CG",
  "Costa Rica": "CR",
  "Croatia": "HR",
  "Cuba": "CU",
  "Cyprus": "CY",
  "Czech Republic": "CZ",
  "Denmark": "DK",
  "Djibouti": "DJ",
  "Dominica": "DM",
  "Dominican Republic": "DO",
  "Ecuador": "EC",
  "Egypt": "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  "Eritrea": "ER",
  "Estonia": "EE",
  "Eswatini": "SZ",
  "Ethiopia": "ET",
  "Fiji": "FJ",
  "Finland": "FI",
  "France": "FR",
  "Gabon": "GA",
  "Gambia": "GM",
  "Georgia": "GE",
  "Germany": "DE",
  "Ghana": "GH",
  "Greece": "GR",
  "Grenada": "GD",
  "Guatemala": "GT",
  "Guinea": "GN",
  "Guinea-Bissau": "GW",
  "Guyana": "GY",
  "Haiti": "HT",
  "Honduras": "HN",
  "Hungary": "HU",
  "Iceland": "IS",
  "India": "IN",
  "Indonesia": "ID",
  "Iran": "IR",
  "Iraq": "IQ",
  "Ireland": "IE",
  "Israel": "IL",
  "Italy": "IT",
  "Jamaica": "JM",
  "Japan": "JP",
  "Jordan": "JO",
  "Kazakhstan": "KZ",
  "Kenya": "KE",
  "Kiribati": "KI",
  "Korea, North": "KP",
  "Korea, South": "KR",
  "Kuwait": "KW",
  "Kyrgyzstan": "KG",
  "Laos": "LA",
  "Latvia": "LV",
  "Lebanon": "LB",
  "Lesotho": "LS",
  "Liberia": "LR",
  "Libya": "LY",
  "Liechtenstein": "LI",
  "Lithuania": "LT",
  "Luxembourg": "LU",
  "Madagascar": "MG",
  "Malawi": "MW",
  "Malaysia": "MY",
  "Maldives": "MV",
  "Mali": "ML",
  "Malta": "MT",
  "Marshall Islands": "MH",
  "Mauritania": "MR",
  "Mauritius": "MU",
  "Mexico": "MX",
  "Micronesia": "FM",
  "Moldova": "MD",
  "Monaco": "MC",
  "Mongolia": "MN",
  "Montenegro": "ME",
  "Morocco": "MA",
  "Mozambique": "MZ",
  "Myanmar": "MM",
  "Namibia": "NA",
  "Nauru": "NR",
  "Nepal": "NP",
  "Netherlands": "NL",
  "New Zealand": "NZ",
  "Nicaragua": "NI",
  "Niger": "NE",
  "Nigeria": "NG",
  "North Macedonia": "MK",
  "Norway": "NO",
  "Oman": "OM",
  "Pakistan": "PK",
  "Palau": "PW",
  "Palestine": "PS",
  "Panama": "PA",
  "Papua New Guinea": "PG",
  "Paraguay": "PY",
  "Peru": "PE",
  "Philippines": "PH",
  "Poland": "PL",
  "Portugal": "PT",
  "Qatar": "QA",
  "Romania": "RO",
  "Russia": "RU",
  "Rwanda": "RW",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Vincent and the Grenadines": "VC",
  "Samoa": "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  "Senegal": "SN",
  "Serbia": "RS",
  "Seychelles": "SC",
  "Sierra Leone": "SL",
  "Singapore": "SG",
  "Slovakia": "SK",
  "Slovenia": "SI",
  "Solomon Islands": "SB",
  "Somalia": "SO",
  "South Africa": "ZA",
  "South Sudan": "SS",
  "Spain": "ES",
  "Sri Lanka": "LK",
  "Sudan": "SD",
  "Suriname": "SR",
  "Sweden": "SE",
  "Switzerland": "CH",
  "Syria": "SY",
  "Taiwan": "TW",
  "Tajikistan": "TJ",
  "Tanzania": "TZ",
  "Thailand": "TH",
  "Togo": "TG",
  "Tonga": "TO",
  "Trinidad and Tobago": "TT",
  "Tunisia": "TN",
  "Turkey": "TR",
  "Turkmenistan": "TM",
  "Tuvalu": "TV",
  "Uganda": "UG",
  "Ukraine": "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United States": "US",
  "Uruguay": "UY",
  "Uzbekistan": "UZ",
  "Vanuatu": "VU",
  "Vatican City": "VA",
  "Venezuela": "VE",
  "Vietnam": "VN",
  "Yemen": "YE",
  "Zambia": "ZM",
  "Zimbabwe": "ZW"
};